import { useEffect, useState } from "react";
import { Doughnut } from "react-chartjs-2";
import styles from "./ComparisonGraph.module.css";

/* ---------------- COMPONENT ---------------- */
function DoughnutHistory({ current }) {
    const EMPTY_CHART = {
        labels: [],
        datasets: [],
    };

    const [currentChartData, setCurrentChartData] = useState(EMPTY_CHART);

    function getRandomColor() {
        const r = Math.floor(Math.random() * 200);
        const g = Math.floor(Math.random() * 200);
        const b = Math.floor(Math.random() * 200);
        return `rgba(${r}, ${g}, ${b}, 0.8)`;
    }

    function convertToDoughnutData(source) {
        if (!source || !source.datasets || !source.headers) return EMPTY_CHART;

        const labels = source.headers;

        const avgValues = source.datasets.map(ds => {
            const nums = ds.data
                .map(v => Number(v))
                .filter(v => !isNaN(v));

            if (!nums.length) return 0;

            const sum = nums.reduce((a, b) => a + b, 0);
            return +(sum / nums.length).toFixed(2);
        });

        return {
            labels,
            datasets: [
                {
                    data: avgValues,
                    backgroundColor: labels.map(() => getRandomColor()),
                    borderWidth: 1,
                },
            ],
        };
    }

    useEffect(() => {
        setCurrentChartData(convertToDoughnutData(current));
    }, [current]);


    const chartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        cutout: "65%",
        plugins: {
            legend: {
                position: "right",
                labels: {
                    boxWidth: 12,
                    font: { size: 10 },
                },
            },
            tooltip: {
                callbacks: {
                    label: ctx => `${ctx.label}: ${ctx.parsed}`,
                },
            },
        },
    };

    return (
        <div className={styles.graphWrapper} style={{ gridTemplateColumns: "1fr" }}>
            <div className={styles.graphContainer}>
                <div className={styles.chartBox} style={{ height: "350px" }} >
                    {currentChartData.labels.length > 0 && (
                        <Doughnut
                            data={currentChartData}
                            options={chartOptions}
                            plugins={[{
                                id: 'centerText',
                                beforeDraw(chart) {
                                    const { ctx, chartArea } = chart;
                                    const dataset = chart.data.datasets[0];

                                    const total = dataset.data
                                        .map(v => Number(v))
                                        .filter(v => !isNaN(v))
                                        .reduce((a, b) => a + b, 0)
                                        .toFixed(2);

                                    const centerX = (chartArea.left + chartArea.right) / 2;
                                    const centerY = (chartArea.top + chartArea.bottom) / 2;

                                    ctx.save();
                                    ctx.font = 'bold 18px sans-serif';
                                    ctx.fillStyle = '#333';
                                    ctx.textAlign = 'center';
                                    ctx.textBaseline = 'middle';
                                    ctx.fillText(`${total}`, centerX, centerY);
                                    ctx.restore();
                                }
                            }]}
                        />
                    )}
                </div>
            </div>

        </div>
    );
}

export default DoughnutHistory;
